// Generated types for ProductMatchTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityMatchTaskReadAPI, EntityMatchTaskWriteAPI } from './entitymatchtask';
import { EntityMatchTaskReadAPISchemaObject, EntityMatchTaskWriteAPISchemaObject } from './entitymatchtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ProductMatchTaskReadAPI extends EntityMatchTaskReadAPI {
}

export interface ProductMatchTaskWriteAPI extends EntityMatchTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ProductMatchTaskReadAPISchema: z.ZodType<ProductMatchTaskReadAPI> = EntityMatchTaskReadAPISchemaObject.extend({}).passthrough();

export const ProductMatchTaskWriteAPISchema: z.ZodType<ProductMatchTaskWriteAPI> = EntityMatchTaskWriteAPISchemaObject.extend({}).passthrough();
